import React from 'react';

import CategoryForm from './components/CategoryForm';

const CategoriesForm = () => {
  return (<CategoryForm />);
}

export default CategoriesForm;
